import { ReduxService } from 'dashboard-services/services';

import { selectedUserRolesActions } from 'actions/modules/myAccount';

export const selectedUserRolesInitialState = {
  addedRoles: [],
  removedRoles: [],
  roles: [],
}

export default (state = selectedUserRolesInitialState, action) => {
  switch (action.type) {
    case selectedUserRolesActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case selectedUserRolesActions.CLEAN_CHANGES:
      return ReduxService.updateObject(state, { removedRoles: [],  addedRoles: [] })
    case selectedUserRolesActions.CLEAN_ALL:
      return selectedUserRolesInitialState;
    default:
      return state; 
  }
}